import { ReportDefinition } from '../models/report-definition';
import { OUT_OF_ORDER_ROOMS_DEFINITION } from './out-of-order-rooms.definition';
import { PAYMENT_REFUNDS_DEF } from './payment-refunds.definition';
import { CASHIER_SUMMARY_DEFINITION } from './cashier-summary.definition';
import { PMS_REVENUE_ADJUSTMENTS_DEFINITION } from './pms-revenue-adjustments.definition';
import { OPEN_FOLIOS_DEFINITION } from './open-folios.definition';
import { HOUSEKEEPING_VARIANCE_DEFINITION } from './housekeeping-variance.definition';
import { TA_COMMS_DEFINITION } from './ta-comms.definition';
import { PAID_OUTS_DEFINITION } from './paid-outs.definition';
import { GUEST_CREDIT_LIMIT_DEFINITION } from './guest-credit-limit.definition';
import { COMPLIMENTARY_ROOMS_DEFINITION } from './complimentary-rooms.definition';
import { PM_ACCOUNTS_DEFINITION } from './pm-accounts.definition';
import { AR_ACTIVITY_DEFINITION } from './ar-activity.definition';

// Single registry
const DEFINITIONS = {
   [OUT_OF_ORDER_ROOMS_DEFINITION.reportType]: OUT_OF_ORDER_ROOMS_DEFINITION,
   [PAYMENT_REFUNDS_DEF.reportType]: PAYMENT_REFUNDS_DEF,
   [CASHIER_SUMMARY_DEFINITION.reportType]: CASHIER_SUMMARY_DEFINITION,
   [PMS_REVENUE_ADJUSTMENTS_DEFINITION.reportType]:
      PMS_REVENUE_ADJUSTMENTS_DEFINITION,
   [OPEN_FOLIOS_DEFINITION.reportType]: OPEN_FOLIOS_DEFINITION,
   [HOUSEKEEPING_VARIANCE_DEFINITION.reportType]: HOUSEKEEPING_VARIANCE_DEFINITION,
   [TA_COMMS_DEFINITION.reportType]: TA_COMMS_DEFINITION,
   [PAID_OUTS_DEFINITION.reportType]: PAID_OUTS_DEFINITION,
   [GUEST_CREDIT_LIMIT_DEFINITION.reportType]: GUEST_CREDIT_LIMIT_DEFINITION,
   [COMPLIMENTARY_ROOMS_DEFINITION.reportType]: COMPLIMENTARY_ROOMS_DEFINITION,
   [PM_ACCOUNTS_DEFINITION.reportType]: PM_ACCOUNTS_DEFINITION,
   [AR_ACTIVITY_DEFINITION.reportType]: AR_ACTIVITY_DEFINITION
} as const satisfies Record<string, ReportDefinition>;

// Typed reportType union
export type ReportType = keyof typeof DEFINITIONS;

export function getReportDefinition(reportType: string): ReportDefinition | null {
   return DEFINITIONS[reportType] ?? null;
}

// Optional: safer getter if you want strict typing in the component
export function getReportDefinitionStrict(reportType: ReportType): ReportDefinition {
   return DEFINITIONS[reportType];
}
